<template>
  <div class="view">
    <div class="brand-channel clearfix" id="h-brand_0" data-type="range" data-lift="品牌">
      <div class="home-brand-adv slide_lr_info">
        <a href="" target="_blank"><img class="slide_lr_img"
            src="https://static.ddtwj.com/data/gallery_album/2/original_img/2_P_1555562791809.jpg"></a>
      </div>
      <div id="topMarquee" class="topLoop">
        <div :class="'bd' + ' ' + index" v-for="(item, index) in brand_group" :key="index">
          <div class="tempWrap" style="overflow:hidden; position:relative; height:155px">
            <ul class="picList" style="height: 1440px; position: relative; padding: 0px; margin: 0px; top: -760px;">
              <li style="height: 155px;" v-for="(s_item, s_index) in item" :key="s_index">
                <div class="pic">
                  <router-link :to="{
                    path: '/good/list',
                    query: { sid: s_item.id, type: 2 },
                  }">
                    <a href=""><img :src="s_item.logo"></a>
                  </router-link>

                </div>
                <div class="title"><a href="">{{s_item.name}}</a></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '@/assets/plugins/jquery.SuperSlide.2.1.1.js'
  import {
    brand_list
  } from "@/api/store";
  export default {
    name: 'BrandArea',
    data() {
      return {
        brand_list: [],
        brand_group: []
      }
    },
    methods: {
      group(array, subGroupLength) {
        let index = 0;
        let newArray = [];
        while (index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
        }
        return newArray;
      },
      group_brand(data) {
        let length = parseInt(data.length / 4) + 1
        this.brand_group = this.group(data, length)
      }
    },
    mounted() {
      var that = this
      if (!localStorage.getItem('brand_list') || localStorage.getItem('brand_list') == 'undefined') {
        brand_list().then((res) => {
          that.brand_list = res.data.brand_list
          localStorage.setItem('brand_list', JSON.stringify(that.brand_list))
        })
      } else {
        that.brand_list = JSON.parse(localStorage.getItem('brand_list'))
      }
      if (that.brand_list.length > 0) {
        that.group_brand(that.brand_list);
      }
      this.$nextTick(function () {
        jQuery(".topLoop").slide({
          mainCell: ".bd.0 ul",
          autoPage: true,
          autoPlay: true,
          delayTime: 5000,
          effect: "topMarquee",
          interTime: 30,
          vis: 1,
        });
        jQuery(".topLoop").slide({
          mainCell: ".bd.1 ul",
          autoPage: true,
          autoPlay: true,
          delayTime: 5000,
          effect: "topMarquee",
          interTime: 30,
          vis: 1,
        });
        jQuery(".topLoop").slide({
          mainCell: ".bd.2 ul",
          autoPage: true,
          autoPlay: true,
          delayTime: 5000,
          effect: "topMarquee",
          interTime: 30,
          vis: 1,
        });
        jQuery(".topLoop").slide({
          mainCell: ".bd.3 ul",
          autoPage: true,
          autoPlay: true,
          delayTime: 5000,
          effect: "topMarquee",
          interTime: 30,
          vis: 1,
        });
      })
    },
  }
</script>

<style scoped>
  .picList .title {
    text-align: center;
  }

  /* 通用图片列表_普通式 */
  .picList li {
    width: 126px;
  }

  .picList .pic {
    text-align: center;
    line-height: 0px;
  }

  .picList .pic img {
    width: 120px;
    height: 90px;
    padding: 2px;
    border: 1px solid #ccc;
  }

  .picList .pic a:hover img {
    border-color: #f00;
  }

  .picList .title {
    line-height: 24px;
  }

  /* 多个上滚动 - 公用类 */
  .topLoop {
    overflow: hidden;
    position: relative;
    display: inline-flex;

  }

  .topLoop .hd {

    overflow: hidden;
    height: 30px;
    background: #f4f4f4;
  }

  .topLoop .hd ul {
    float: right;
    overflow: hidden;
    zoom: 1;
    margin-top: 10px;
  }

  .topLoop .hd ul li {
    position: relative;
    _display: inline;
    float: left;
    width: 10px;
    height: 10px;
    overflow: hidden;
    background: #ccc;
    margin-right: 10px;
    text-indent: -999px;
    cursor: pointer;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    behavior: url();
  }

  .topLoop .hd ul li.on {
    background: #f00;
  }

  .topLoop .bd {
    margin-left: 30px;
    padding: 10px;
  }

  .topLoop .bd ul {
    overflow: hidden;
    zoom: 1;
  }

  .brand-channel {
    width: 100%;
    margin-top: 20px;
  }

  .brand-channel .home-brand-adv {
    width: 474px;
    height: 178px;
    float: left;
    margin-right: 10px;
    overflow: hidden;
  }

  .view {
    width: 1200px;
    margin: auto;
  }
</style>
